import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from 'react';
import alertSoundShort from '@assets/alert_short.mp3';

const AlertSoundContext = createContext(null);

export const useAlertSound = () => {
  const playAlert = useContext(AlertSoundContext);
  return playAlert;
};

export const AlertSoundProvider = ({ children }) => {
  const audioRef = useRef(null);
  const [isUnlocked, setIsUnlocked] = useState(false);

  // Créer l'objet Audio une seule fois
  useEffect(() => {
    audioRef.current = new Audio(alertSoundShort);
    audioRef.current.volume = 0.25;
  }, []);

  // Débloquer l'audio au premier clic/interaction
  useEffect(() => {
    const unlockAudio = () => {
      if (!isUnlocked && audioRef.current) {
        // Jouer un son silencieux pour débloquer
        audioRef.current.play().then(() => {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          setIsUnlocked(true);
          console.log('Audio unlocked!');
        }).catch(() => {
          // Ignorer l'erreur, on réessaiera au prochain clic
        });
      }
    };

    document.addEventListener('click', unlockAudio);
    document.addEventListener('keydown', unlockAudio);
    document.addEventListener('touchstart', unlockAudio);

    return () => {
      document.removeEventListener('click', unlockAudio);
      document.removeEventListener('keydown', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
    };
  }, [isUnlocked]);

  const playAlert = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(err => console.error('Audio play error:', err));
    }
  }, []);

  return (
    <AlertSoundContext.Provider value={playAlert}>
      {children}
    </AlertSoundContext.Provider>
  );
};

export default AlertSoundContext;
